import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EditIcon from '@mui/icons-material/Edit';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';
import OrderStatus from 'components/OrderStatus';
import OwnerWithEmailLink from 'components/OwnerWithEmailLink';

import { OrderListRow_order$key } from '__generated__/OrderListRow_order.graphql';

type Props = EntityTableRowProps & {
  order: OrderListRow_order$key;
};

const OrderListRow: FC<Props> = ({ order, ...props }) => {
  const orderData = useFragment(
    graphql`
      fragment OrderListRow_order on Order {
        id
        orderNr
        name
        time
        priceTotal
        priceAdvancePayment
        adminComment

        pack {
          id
        }

        ...EntityTableRow_entity
        ...OwnerWithEmailLink_order
        ...OrderStatus_order
      }
    `,
    order
  );

  const {
    id,
    orderNr,
    name,
    time,
    pack,
    priceAdvancePayment,
    priceTotal,
    adminComment,
  } = orderData;

  return (
    <EntityTableRow
      entity={orderData}
      actions={
        <IconButton href={id} color="success" size="small">
          <EditIcon fontSize="small" />
        </IconButton>
      }
      {...props}>
      <TableCell>
        <Link href={id}>{orderNr}</Link>
      </TableCell>

      <TableCell center>{time}</TableCell>

      <TableCell center>
        <OrderStatus order={orderData} />
      </TableCell>

      <TableCell center>
        <OwnerWithEmailLink order={orderData} />
      </TableCell>

      <TableCell center>
        {pack ? <Link href={`/packages/${pack.id}`}>{name}</Link> : name}
      </TableCell>

      <TableCell center>
        {priceAdvancePayment} / {priceTotal}
      </TableCell>

      <TableCell center>{adminComment}</TableCell>
    </EntityTableRow>
  );
};

export default OrderListRow;
